import { useContext, useRef, useState } from 'react'
import { Form } from '@unform/web'
import {
  DefaultButton,
  Input,
  Loading,
  Feedback,
  ButtonNext,
} from 'components/index'
import useFetch from 'hooks/useFetch'
import { UserContext } from 'context/userContext'
import { IResponse } from 'interfaces'
import Div from './style'

interface IProps {
  hasButtonBack?: boolean
}

export default function SecurityConfirm({ hasButtonBack }: IProps) {
  const {
    loading,
    setLoading,
    requestFn,
    feedback,
    page,
    setPage,
    setPreview,
    setData,
  } = useContext(UserContext)
  const [password, setPassword] = useState<string>('')
  const [buttonLoading, setButtonLoading] = useState(false)
  const [showFeedback, setShowFeedback] = useState<boolean>(false)
  const formRef = useRef<HTMLFormElement | any>(null)

  const api = useFetch()

  const submit = async () => {
    if (buttonLoading) return
    formRef.current.setErrors({})
    try {
      setButtonLoading(true)
      const response: IResponse = await api.fetch(
        'post',
        { password },
        '/gestor/verify-password'
      )
      if (response.fail) {
        setButtonLoading(false)
        return formRef.current.setErrors({ password: response.errors.message })
      }

      const r = await requestFn.current()
      if (r.fail) {
        setButtonLoading(false)
        return formRef.current.setErrors({ password: r.errors.message })
      }
      console.log(r)
      // setButtonLoading(false)
      setPreview('')
      setData({})
      setLoading(true)
      setLoading(false)
      setShowFeedback(true)
    } catch (err: any) {
      console.log('err', err)
      setButtonLoading(false)
      setLoading(false)
      formRef.current.setErrors({ password: err.message })
    }
  }

  if (showFeedback) return <Feedback />
  if (loading) return <Loading modal />

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Div>
        <div className="security-confirm-container">
          <h1 className="security-confirm-h1">Confirmação de segurança</h1>
          <span className="security-confirm-span">
            Digite aqui a sua senha para confirmar a operação.
          </span>
          <Form
            // onSubmit={(e) => e.preventDefault()}
            onSubmit={() => console.log('alou')}
            className="login-form"
            autoComplete="off"
            ref={formRef}
          >
            <Input
              secondary
              onChange={(e: any) => setPassword(e.target.value)}
              name="password"
              type="password"
              placeholder="Senha"
              value={password}
              // error={error}
            />
            <DefaultButton
              onClick={submit}
              secondary
              $loading={buttonLoading}
              style={{ marginTop: 20 }}
            >
              Confirmar
            </DefaultButton>
          </Form>
        </div>
      </Div>
      <div style={{ justifySelf: 'flex-start', alignSelf: 'flex-start' }}>
        {hasButtonBack && (
          <ButtonNext isBack backPage={() => setPage((prev) => prev - 1)} />
        )}
      </div>
    </div>
  )
}
